import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Check } from "lucide-react"
import { useAppCtx } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { Form, FormButton, FormLabel, FieldGroup, InputField, SelectField } from "lib/components"

export default function TemplateSetup(){

  const { tmplid } = useParams()
  
  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {})
  
  const saveFn = queryTools.resource.save(["template.all"])

  const [ templateForm, setTemplateForm ] = useState<any>()

  async function handleTemplateSave(e:any){
    e.preventDefault()
    const formData:any = new FormData(e.target)
    const data = Object.fromEntries(formData.entries())
    saveFn.mutate({ resource: "template", data: {...data, _id: _Template._id} })
  }

  const processingOpts = [
    { value: "send", label: "Send the html + css to the Midmetrics server." },
    { value: "generate", label: "Generate the PDF here, but do not engage any of the editing modules." },
    { value: "generate+edit", label: "Generate the PDF here, and engage any editing modules that have been selected." }
  ]

  const handleInputChange = (e:any) => {
    const { name, value } = e.target
    setTemplateForm({...templateForm, [name]: value })
  }

  useEffect(() => {
    if( _Template && !templateForm ){
      setTemplateForm(_Template)
    }
  },[_Template])

  if( !_Template || !templateForm || !_Clients ) return <></>
  return (
    <div className="w-full h-full *:text-neutral-200">
      <Form className="w-full flex flex-col justify-start items-start gap-4" onSubmit={handleTemplateSave}>

        <div className="w-full flex justify-start items-start gap-24 px-8 mt-6">
          <div className="w-6/12 flex flex-col">
            <h3 className="text-base uppercase pb-1 mb-3 border-b border-solid border-slate-700">Basics</h3>

            <FieldGroup className="w-24" label="Midmetrics Id" required={true}>
              <InputField name="Id" placeholder="Id" value={templateForm.Id} onChange={handleInputChange} />
            </FieldGroup>

            <FieldGroup className="w-full grow" label="Title" required={true}>
              <InputField name="Title" placeholder="Already Refunded" value={templateForm.Title} onChange={handleInputChange} />
            </FieldGroup>

            <FieldGroup className="w-full grow-0" label="Owner" required={true}>
              <div className="w-full border border-solid border-slate-700 rounded-sm h-8 flex justify-start items-center bg-slate-900 outline-transparent outline outline-offset-2 text-sm text-gray-200 px-2 py-.5 cursor-not-allowed">{_Template.AssignedTo?.name || "[none]"}</div>
            </FieldGroup>
          </div>

          <div className="w-6/12 flex flex-col">
            <h3 className="text-base uppercase pb-1 mb-3 border-b border-solid border-slate-700">Processing</h3>
            <p>When a request is received for this template, how should it be processed:</p>

            <div className="w-full flex flex-col gap-8 mt-4">

              { processingOpts.map( (opt:any) => (
                <div key={opt.value} className="w-full flex justify-start items-start gap-4">
                  <div 
                      onClick={() => setTemplateForm({...templateForm, Processing: opt.value })}
                      className="w-5 h-5 bg-transparent border border-solid border-slate-700 flex justify-center items-center relative cursor-pointer"
                    >
                    <Check 
                      className={cn(
                        "text-green-500 w-3 h-3 absolute top-0 left-0 right-0 bottom-0 m-auto z-20",
                        templateForm.Processing !== opt.value && "hidden"
                       )} />
                  </div>
                  {/* <input type="checkbox" name="IsActive" defaultChecked={_Template.IsActive} className="w-5 h-5" /> */}
                  <label>{opt.label}</label>
                </div>
              ))}

            </div>
          </div> 
        </div>

        <div className="w-full mt-4">
          <FieldGroup className="pt-5 w-[8rem]">
            <FormButton>Save Changes</FormButton>
          </FieldGroup>
        </div>
      </Form>
    </div>
  )
}